/**
 * When a platform admin (B2C) uses /orgs to view another tenant, we mint a
 * Supabase JWT with org override and remember the target domain here so
 * OrganizationContext keeps fetching that org after reload.
 */
const STORAGE_KEY = "cardinal_admin_org_domain"

export function getAdminOrgImpersonationDomain(): string | null {
    if (typeof window === "undefined") return null
    try {
        const v = sessionStorage.getItem(STORAGE_KEY)
        return v && v.trim() ? v.trim().toLowerCase() : null
    } catch {
        return null
    }
}

export function setAdminOrgImpersonationDomain(domain: string) {
    if (typeof window === "undefined") return
    sessionStorage.setItem(STORAGE_KEY, domain.trim().toLowerCase())
}

export function clearAdminOrgImpersonation() {
    if (typeof window === "undefined") return
    sessionStorage.removeItem(STORAGE_KEY)
}
